module.exports = __webpack_public_path__ + "img/quidditch_scorekeeping_machine.40903865.jpg";